import React, { useEffect, useState } from 'react';
import CategoryStrip from '../components/home/CategoryStrip';
import ProductCard from '../components/product/ProductCard';
import {
  getCategories,
  getProducts,
  getTextileProducts
} from '../services/productService';
import ExclusiveStrip from '../components/home/ExclusiveStrip';
import { useNavigate } from 'react-router-dom';
import "../css/home.css";
// import Advertisement from '../components/Advertisement/Advertisement';
import Poster from '../components/home/Poster';
import BannerSlider from '../components/home/BannerSlider';
import Poster2 from '../components/home/Poster2';
import Poster3 from '../components/home/Poster3';
import Reels from '../components/home/Reels';
import ProductRail from '../components/product/ProductRail';
import { useSeo, absUrl, siteUrl, DEFAULT_TITLE, DEFAULT_DESCRIPTION } from '../utils/seo';

const NEW_ARRIVALS_LIMIT = 15;
const BEST_SELLERS_LIMIT = 15;
const TRENDING_LIMIT = 15;

const SectionHeader = ({ title, note, onViewAll }) => (
  <div className="m-section-head">
    <div>
      <h2 className="m-section-title" >{title}</h2>
      {note && <p className="m-section-note">{note}</p>}
    </div>
    {onViewAll && (
      <button type="button" className="m-view-all" onClick={onViewAll}>
        View all
      </button>
    )}
  </div>
);

const HomePage = () => {
  useSeo({
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'ClothingStore',
        name: 'Mithralaya',
        url: siteUrl(),
        logo: absUrl('/logo512.png'),
        address: { '@type': 'PostalAddress', addressLocality: 'Chennai', addressRegion: 'Tamil Nadu', addressCountry: 'IN' }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Mithralaya',
        url: siteUrl(),
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl()}/all-product?search={search_term_string}`,
          'query-input': 'required name=search_term_string'
        }
      }
    ]
  }, []);
  const [categories, setCategories] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [trending, setTrending] = useState([]);

  const navigate = useNavigate();
  const viewAllNewArrivals = () => {
    navigate('/all-product?new=true');
  };

  const viewAllBestSellers = () => {
    navigate('/all-product?bestseller=true');
  };

  const viewAllTrending = () => {
    navigate('/all-product?trending=true');
  };

  useEffect(() => {
    const load = async () => {
      try {
        const cats = await getCategories();
        setCategories(Array.isArray(cats) ? cats : []);

        const [bestLegacy, bestTextile] = await Promise.all([
          getProducts({ bestseller: "true" }),
          getTextileProducts({ bestseller: "true" })
        ]);

        const bestList = [
          ...(bestTextile.products || []),
          ...(bestLegacy.products || [])
        ].slice(0, BEST_SELLERS_LIMIT);
        setBestSellers(bestList);

        const [trendLegacy, trendTextile] = await Promise.all([
          getProducts({ trending: "true" }),
          getTextileProducts({ trending: "true" })
        ]);

        setTrending([
          ...(trendTextile.products || []),
          ...(trendLegacy.products || [])
        ].slice(0, TRENDING_LIMIT));
      } catch (error) {
        console.error('Error loading homepage data:', error);
        setCategories([]);
        setBestSellers([]);
        setTrending([]);
      }
    };
    load();
  }, []);

  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        const [legacyData, textileData] = await Promise.all([
          getProducts({ new: 'true' }),
          getTextileProducts({ new: 'true' })
        ]);

        const allProducts = [
          ...(textileData.products || []),
          ...(legacyData.products || [])
        ];

        setNewArrivals(allProducts.slice(0, NEW_ARRIVALS_LIMIT));
      } catch (error) {
        console.error('Error loading new arrivals:', error);
        setNewArrivals([]);
      }
    };
    fetchNewArrivals();
  }, []);


  const renderGrid = (products, emptyText) =>
    products.length > 0 ? (
      <div className="product-grid m-grid">
        {products.map((p) => (
          <ProductCard
            key={p._id}
            product={p}
            hideBadge={true}
            hideMeta={true}
          />
        ))}
      </div>
    ) : (
      <p className="m-empty">{emptyText}</p>
    );

  return (
    <div className="home-page">
      <BannerSlider />
      <CategoryStrip categories={categories} />

      <section className="m-section">
        <SectionHeader
          title="New arrivals"
          note="The latest sarees, kurtis and sets, added every week"
          onViewAll={viewAllNewArrivals}
        />
        {renderGrid(newArrivals, 'New pieces arrive every week. Check back soon.')}
      </section>

      <Poster />
      <ExclusiveStrip />

      <section className="m-section">
        <SectionHeader
          title="Best sellers"
          note="What our customers come back for"
          onViewAll={viewAllBestSellers}
        />
        {renderGrid(bestSellers, 'Our best sellers will appear here soon.')}
      </section>

      <Reels />
      <Poster2 />

      <section className="m-section">
        <SectionHeader
          title="Trending now"
          note="Popular this month"
          onViewAll={viewAllTrending}
        />
        {renderGrid(trending, 'Trending styles will appear here soon.')}
      </section>

      <Poster3 />
    </div>
  );
};

export default HomePage;
